// Component
export {default as IdleWatcher } from './lib/components/IdleWatcher';